import { ADD_CD_TAB_KEYS } from './components/AddCDModal/constants';
import { getMomentDate } from 'util/date';

export const getLinkCDPayload = (values) => {
  const testIds = Object.keys(values[ADD_CD_TAB_KEYS.TEST]).filter(
    (key) => !!values[ADD_CD_TAB_KEYS.TEST][key]
  );
  const certificateIds = Object.keys(values[ADD_CD_TAB_KEYS.CERTIFICATE]).filter(
    (key) => !!values[ADD_CD_TAB_KEYS.CERTIFICATE][key]
  );
  const otherIds = Object.keys(values[ADD_CD_TAB_KEYS.OTHER]).filter(
    (key) => !!values[ADD_CD_TAB_KEYS.OTHER][key]
  );
  return {
    testDataIds: testIds.map((v) => Number(v)),
    certificateDataIds: certificateIds.map((v) => Number(v)),
    otherDataIds: otherIds.map((v) => Number(v)),
  };
};
export const isRequirementCompleted = (qualityRequirements) => {
  const isChecked =
    qualityRequirements?.length > 0 &&
    qualityRequirements.every(
      (obj) =>
        obj.items?.length > 0 &&
        !!obj.items.filter((item) => !!item.isMandatory).every((item) => item.isCompleted)
    );
  return isChecked;
};
export const isRequirementExpired = (qualityRequirements) => {
  const today = getMomentDate('', true).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const dataRecords = [];
  (qualityRequirements || []).forEach((obj) => {
    (obj.items || []).forEach((item) => {
      [
        ...(item.testDataMaps || []),
        ...(item.certificateDataMaps || []),
        ...(item.otherDataMaps || []),
      ].forEach((subItem) => {
        dataRecords.push(subItem);
      });
    });
  });
  const isExpired =
    dataRecords?.length > 0 &&
    dataRecords.filter((obj) => {
      const expiryDate =
        obj?.testData?.expiryDate ||
        obj?.certificateData?.expiryDate ||
        obj?.otherData?.expiryDate ||
        '';
      const tMomentVal = getMomentDate(expiryDate);
      const isThisExpired =
        !!tMomentVal &&
        tMomentVal
          .clone()
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .isBefore(today);
      return isThisExpired;
    }).length > 0;
  return isExpired;
};
export const getConfirmPDFPayload = (productId, documentListIds, values) => {
  const payload = {
    documentListIds,
    supplierIds: [],
    factoryIds: [],
    productIds: [productId],
    tagIds: [],
    issueDate: values.issueDate ? values.issueDate.format('YYYY-MM-DD') : null,
    expiryDate: values.expiryDate ? values.expiryDate.format('YYYY-MM-DD') : null,
    reviewDate: values.reviewDate ? values.reviewDate.format('YYYY-MM-DD') : null,
    reminderDate: values.customDate ? values.customDate.format('YYYY-MM-DD') : null,
    reminderType: values.emailReminder || null,
    note: values.note,
    complianceData: {
      testData: [],
      certificateData: [],
      otherData: [],
    },
  };
  return payload;
};
